import React, { useContext, useRef } from 'react';
import clsx from 'clsx';
import { TextStyled } from '@nike/nike-design-system-components';
import { CaretRight, ProfileStroke } from '@nike/nike-design-system-icons';
import Link from '../Link';
import {
  MENU_OPTION_CLASS,
  PROFILE_IMAGE_CLASS,
  USER_GREETING_LINK_CLASS,
  USER_GREETING_TEXT_CLASS,
} from '../MobileMenu/styles';
import useGetUserGreeting from '../../utils/hooks/getUserGreetingHook';
import AnalyticsEventTypes from '../../utils/analyticsEvent';
import useMenuData from '../../utils/hooks/cmsDataHook';
import { BODEGA_DEFAULTS, DATA_TYPES, MENU_TYPES } from '../../constants';
import useIdentity from '../../utils/hooks/identityHook';
import useBodega from '../../utils/hooks/bodegaHook';
import { FocusContext } from '../MobileMenu';

/**
 * when clicked opens the account sub menu. This component was created
 * so we can pass a useRef into our state and to isolate the settings menu data
 * @returns {React.ReactElement}
 */
const MobileAccountMenu = () => {
  const { openSubMenu } = useContext(FocusContext);
  const allProductMsg = useBodega('nav_title_all_menuitem', BODEGA_DEFAULTS.ALL);
  const { userProfile } = useIdentity();
  const userGreetingMsg = useGetUserGreeting();
  const linkRef = useRef(null);
  const accountSettings = useMenuData(
    DATA_TYPES.HEADER,
    MENU_TYPES.ACCOUNT_SETTINGS_MENU,
  )?.children;

  const accountSettingsData = accountSettings?.[0]?.children?.map(menu => {
    return {
      href: menu?.url,
      url: menu?.url,
      label: menu?.label,
      path: menu?.path,
      type: menu?.type,
      analyticsEventName: AnalyticsEventTypes.CLICK_NAV_ACCOUNT,
    };
  });

  const accountSettingsMenuItems = {
    content: accountSettingsData,
    title: accountSettings?.[0]?.label,
    titleLink: accountSettings?.[0]?.url,
    analyticsEventName: AnalyticsEventTypes.CLICK_NAV_ACCOUNT,
  };
  return (
    <Link
      className={clsx(MENU_OPTION_CLASS, USER_GREETING_LINK_CLASS)}
      dataTestId={'account-menu'}
      key={accountSettingsMenuItems.title}
      onClick={() => {
        openSubMenu(
          accountSettingsMenuItems.content || [],
          allProductMsg,
          accountSettingsMenuItems.title,
          linkRef,
          accountSettingsMenuItems.url,
        );
      }}
      ref={linkRef}
    >
      <TextStyled className={USER_GREETING_TEXT_CLASS}>
        {userProfile?.avatarUrl ? (
          <img className={PROFILE_IMAGE_CLASS} src={userProfile.avatarUrl} />
        ) : (
          <ProfileStroke className={PROFILE_IMAGE_CLASS} />
        )}
        {userGreetingMsg}
      </TextStyled>
      <CaretRight />
    </Link>
  );
};

export default MobileAccountMenu;
